module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-2"
  }, [_c('div', {
    staticClass: "provinceArea",
    style: (_vm.leftHt)
  }, [_c('el-scrollbar', {
    ref: "aaa"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.postDat.sjExamineId,
      "background-color": "#fff",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.provinceChange
    }
  }, _vm._l((_vm.provinceList), function(item, inx) {
    return _c('el-menu-item', {
      key: inx,
      class: {
        'custom-active': _vm.postDat.sjExamineId == item.sjExamineId
      },
      style: (Object.assign({}, _vm.computedColor(item))),
      attrs: {
        "index": item.sjExamineId
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm._f("transStr")(item, "navset")))])])
  }))], 1)], 1), _vm._v(" "), (_vm.postDat.sjExamineId) ? _c('div', {
    staticClass: "contArea"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.pvcName))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v("音像制品出版单位核验")]), _vm._v(" "), _c('div', {
    staticClass: "btnCtrls"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.postBack(1)
      }
    }
  }, [_vm._v("整体发布")]), _vm._v(" "), (_vm.pvcSta == 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.postDat.msg == '';
      }
    }
  }, [_vm._v("整体退回")]) : _vm._e(), _vm._v(" "), (_vm.postUrl) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrl)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局分析报告")])], 1) : _c('el-button', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    }
  }, [_vm._v("省局分析报告（未上传）")]), _vm._v(" "), (_vm.postUrlZg) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrlZg)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局整改报告")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("核验意见")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v("注销或拟注销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.status == 0 ||
          scope.row.status == 1 ||
          scope.row.status == 2 ||
          scope.row.status == 4 ||
          scope.row.status == 5
        ) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("进入\n              ")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "批准文号",
      "prop": "pubNumber",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, "time")) + "\n            ")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])]) : _c('div', {
    staticClass: "unProvince"
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_audio_pop",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeHandle
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [_c('span', [_vm._v("请填写整体退回意见")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "rows": "5",
      "placeholder": "请输入内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.postDat.msg),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "msg", $$v)
      },
      expression: "postDat.msg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.postBack(2)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_audio_pop",
    attrs: {
      "title": "请填写意见",
      "width": "40%",
      "center": "",
      "visible": _vm.dialogShow
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [(_vm.paramsEx.status == 3) ? _c('span', [_vm._v("请填写退回意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 22) ? _c('span', [_vm._v("请填写整改意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 2) ? _c('span', [_vm._v("请填写暂缓意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 4) ? _c('span', [_vm._v("请填写撤销意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 5) ? _c('span', [_vm._v("请填写注销意见")]) : _vm._e()]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.paramsEx.message),
      callback: function($$v) {
        _vm.$set(_vm.paramsEx, "message", $$v)
      },
      expression: "paramsEx.message"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnFun
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f1dfb2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminRole/audioFExam.vue
// module id = 1783
// module chunks = 1